"use client";

import { c as _c } from "react/compiler-runtime";
import { QueryClientProvider, type QueryClient } from "@tanstack/react-query";
import { httpBatchStreamLink, httpLink, isNonJsonSerializable, loggerLink, splitLink } from "@trpc/client";
import { createTRPCReact } from "@trpc/react-query";
import { type inferRouterInputs, type inferRouterOutputs } from "@trpc/server";
import { useState } from "react";
import SuperJSON from "superjson";
import { type AppRouter } from "@/utils/trpc/api/root";
import { createQueryClient } from "./query-client";
let clientQueryClientSingleton: QueryClient | undefined = undefined;
const getQueryClient = () => {
  if (typeof window === "undefined") {
    // Server: always make a new query client
    return createQueryClient();
  }
  // Browser: use singleton pattern to keep the same query client
  clientQueryClientSingleton ??= createQueryClient();
  return clientQueryClientSingleton;
};
export const api = createTRPCReact<AppRouter>();
const {
  Provider: TRPCProvider,
  createClient
} = api;
/**
 * Inference helper for inputs.
 *
 * @example type HelloInput = RouterInputs['example']['hello']
 */
export type RouterInputs = inferRouterInputs<AppRouter>;

/**
 * Inference helper for outputs.
 *
 * @example type HelloOutput = RouterOutputs['example']['hello']
 */
export type RouterOutputs = inferRouterOutputs<AppRouter>;
export function TRPCReactProvider(props) {
  const $ = _c(4);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = getQueryClient();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const queryClient = t0;
  const [trpcClient] = useState(_temp5);
  let t1;
  if ($[1] !== props.children || $[2] !== trpcClient) {
    t1 = <QueryClientProvider client={queryClient}><TRPCProvider client={trpcClient} queryClient={queryClient}>{props.children}</TRPCProvider></QueryClientProvider>;
    $[1] = props.children;
    $[2] = trpcClient;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}
function _temp5() {
  return createClient({
    links: [splitLink({
      condition: _temp,
      true: httpLink({
        url: getBaseUrl() + "/api/trpc",
        transformer: {
          serialize: _temp2,
          deserialize: SuperJSON.deserialize
        }
      }),
      false: httpBatchStreamLink({
        transformer: SuperJSON,
        url: getBaseUrl() + "/api/trpc",
        headers: _temp3
      })
    }), loggerLink({
      enabled: _temp4
    })]
  });
}
function _temp4(op_0) {
  return process.env.NODE_ENV === "development" || op_0.direction === "down" && op_0.result instanceof Error;
}
function _temp3() {
  const headers = new Headers();
  headers.set("x-trpc-source", "nextjs-react");
  return headers;
}
function _temp2(data) {
  return data;
}
function _temp(op) {
  return op.input instanceof FormData;
}
function getBaseUrl() {
  if (typeof window !== "undefined") return window.location.origin;
  return `http://localhost:${process.env.PORT ?? 3000}`;
}